import { FC } from "react";
import { Flex, Text } from "@chakra-ui/react";
import {
  CONSUMER_HEALTH_PRIVACY_NOTICE_URL,
  PRIVACY_POLICY_URL,
  routes,
  sharedProps,
  TERMS_OF_SERVICE_URL,
} from "~/constants";
import { trackFooter as track } from "~/events";
import { FooterLink } from "./FooterLink";
import { LinkDivider } from "./LinkDivider";

const text = {
  company: "Conceive © ",
  chpNotice: "Consumer Health Privacy Notice",
  faqs: "FAQs",
  privacyPolicy: "Privacy Policy",
  tos: "Terms of Service",
};

export const RequiredLinks: FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Flex align="center" direction="column" {...sharedProps.max.content}>
      <Flex wrap="wrap" align="center" justify="center">
        <Text color="fg-on-accent" size="lg">
          {text.company}
          {currentYear}
        </Text>

        {LinkDivider}

        <FooterLink onClick={track.faqsLink} to={routes.faqs}>
          {text.faqs}
        </FooterLink>

        <FooterLink
          isExternalLink
          onClick={track.privacyPolicyLink}
          to={PRIVACY_POLICY_URL}
        >
          {text.privacyPolicy}
        </FooterLink>

        <FooterLink
          isExternalLink
          onClick={track.termsOfServiceLink}
          to={TERMS_OF_SERVICE_URL}
        >
          {text.tos}
        </FooterLink>

        <FooterLink
          isExternalLink
          onClick={track.chpNoticeLink}
          to={CONSUMER_HEALTH_PRIVACY_NOTICE_URL}
          isLast
        >
          {text.chpNotice}
        </FooterLink>
      </Flex>
    </Flex>
  );
};
